import {
  useSortable,
  SortableContext,
  horizontalListSortingStrategy,
  verticalListSortingStrategy
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { useLevelPlaySurface } from '@/shared/level-play'

import { SortedGameWord } from './Word'

export const SortedGameBoard = ({ id, items, ignoreOrder }) => {
  const { disableInputs } = useLevelPlaySurface()
  const {
    active,
    attributes,
    isDragging,
    listeners,
    over,
    setNodeRef,
    transition,
    transform
  } = useSortable({
    id,
    data: {
      type: 'container',
      children: items
    }
  })
  const isOverContainer = over
    ? (id === over.id && active?.data.current?.type !== 'container') ||
      items.includes(over.id)
    : false
  let classes =
    'flex flex-row flex-wrap items-start content-start gap-4 w-full grow min-h-[100px]'
  if (id === 'correctWords') {
    classes += ` w-full rounded-xl min-h-[125px] flex flex-row flex-wrap items-start content-start gap-3 md:gap-3 p-4 lg:p-6 border-2 border-gray-300 shrink-0 ${
      isOverContainer ? 'bg-gray-200' : 'bg-gray-100'
    } `
  }

  return (
    <div
      className={`flex flex-col w-full ${
        id === 'wrongWords' ? 'grow shrink' : 'shrink-0'
      }`}
    >
      <SortableContext
        id={id}
        items={items}
        strategy={verticalListSortingStrategy}
        disabled={disableInputs}
      >
        <div
          id={id}
          ref={setNodeRef}
          //   transition,
          //   transform: CSS.Translate.toString(transform),
          //   opacity: isDragging ? 0.5 : undefined
          className={classes}
        >
          {items.map(id => (
            <SortedGameWord key={id} id={id} text={id} />
          ))}
        </div>
      </SortableContext>
      {id == 'correctWords' && (
        <span className="text-gray-700 text-sm font-medium block w-full text-left bg-gray-300 pt-5 px-4 pb-2 rounded-xl -mt-4 z-[-1]">
          {id == 'correctWords'
            ? `Arraste as expressões corretas para esta área
            ${ignoreOrder ? 'em qualquer ordem' : 'na ordem correta'}`
            : 'Lista de expressões'}
        </span>
      )}
    </div>
  )
}
